import { Component, OnInit } from '@angular/core';
import { ORDERHISTORY } from 'src/app/config';
import { ApiService } from 'src/app/api.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-account-orders',
    templateUrl: './account-orders.component.html',
    styleUrls: ['./account-orders.component.css'],
    
})
export class AccountOrdersComponent implements OnInit {

  orders:any;
  loader:boolean;
 page:boolean;
 alert:boolean;
   constructor(private api:ApiService,private router:Router) { }
   orderDetail(id)
   {
     this.router.navigate(['order-detail',id]);
   }
   ngOnInit() {
     this.loader=true;
     this.page=false;
     this.api.Get(ORDERHISTORY).then(data=>{
       this.page=true;
       this.loader=false;
       this.orders=data['data'];
      
     }).catch(d=>{
       if( d.status == 503){
         this.api.onFail('Your session is expired please login again','Login Again');
         this.api.setGoto();
         this.api.setlogin(0);
         this.api.logout();
         setTimeout(() => {
         this.router.navigate(['/login']);
         },1000);
       } else{
       this.alert=true;
       this.loader=false;
       this.page=false;
       }
     });
   }

}
